import React, { useState } from 'react';
import BankingTypeContext from './context';

import * as SELECTORS from '../../constants/selectors';

/**
 * withBankingType higher order component
 * Defines context and state of the Banking Type Demo to display
 * By default it will be 'olb' - Online Banking
 * Other option will be 'mb' - Mobile Banking
 * @param {*} Component 
 */
const withBankingType = Component => {

    // Internal component to handle context and state
    function Comp(props) {

        // State
        const [bankingType, setBankingType] = useState(SELECTORS.MB);

        return (
            <BankingTypeContext.Provider value={{ bankingType, setBankingType }}>
                <Component {...props} />
            </BankingTypeContext.Provider>
        );

    }

    return Comp;
};

export default withBankingType;